const md5 = require('md5')

const getRoomName = id => {
  return md5(String(id))
}

export default getRoomName
